<template>
    <wizard-layout :id="this.step">
        <template>
            <wizard-box-left>

                <div class="loader-container d-none h-100">
                    <div class="d-flex align-items-center flex-column justify-content-center h-100">
                        <div class="loader"></div>
                        <p class="mt-3">Stiamo inviando la tua richiesta</p>
                    </div>
                </div>

                <div id="content-step-7">
                    <wizard-step :step="this.step" :header_step="this.header_step" :user="this.user"></wizard-step>
                    <wizard-header :title="this.title"></wizard-header>

                    <div class="row" v-if="isAgency()">
                        <div class="col-12 mb-3 d-flex">
                            <div class="col-lg-6 col-12">
                                <label>Qual è il prezzo di vendita richiesto dal cliente?*</label>
                            </div>
                            <div class="col-lg-6 col-12">
                                <div class="form-control custom-form-control">
                                    <span class="before-input">€</span><input class="custom-input-control" type="text" v-model="client_request_price" />
                                </div>
                            </div>
                        </div>

                        <div class="col-12 mb-3 d-flex">
                            <div class="col-lg-6 col-12">
                                <label>Il prezzo è trattabile?</label>
                            </div>
                            <div class="col-lg-6 col-12">
                                <input class="form-control" type="text" v-model="negotiable_price" placeholder="Sì, è disposto a scendere di.." />
                            </div>
                        </div>

                        <div class="col-12 mb-3 d-flex">
                            <div class="col-lg-6 col-12">
                                <label>Quanto vale secondo te l’immobile allo stato attuale?*</label>
                            </div>
                            <div class="col-lg-6 col-12">
                                <div class="form-control custom-form-control">
                                    <span class="before-input">€</span><input class="custom-input-control" type="text" v-model="actual_agency_price" />
                                </div>
                            </div>
                        </div>

                        <div class="col-12 mb-3 d-flex">
                            <div class="col-lg-6 col-12">
                                <label>Qual è il prezzo a cui puoi venderlo completamente ristrutturato?</label>
                            </div>
                            <div class="col-lg-6 col-12">
                                <div class="form-control custom-form-control">
                                    <span class="before-input">€</span><input class="custom-input-control" type="text" v-model="after_restoration_agency_price" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-else>
                        <div class="col-12 mb-4">
                            <div class="row">
                                <div class="col-lg-3 col-12">
                                    <label>Valore immobile*</label>
                                </div>
                                <div class="col-lg-9 col-12">
                                    <div class="form-control custom-form-control">
                                        <span class="before-input">€</span><input class="custom-input-control" type="text" v-model="expected_value" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <wizard-footer :step="this.step"
                                   :display_next_button="display_next_button"
                                   :wizard_data="getWizardData"
                                   :user="this.user"
                    >
                    </wizard-footer>
                </div>

            </wizard-box-left>
            <wizard-box-right :id="this.step">
                <wizard-progress :progress="this.progress" :progress_title="this.progress_title" :progress_description="this.progress_description"></wizard-progress>

            </wizard-box-right>
        </template>
    </wizard-layout>
</template>

<script>

import WizardLayout from "@/Pages/Wizard/Layouts/WizardLayout";
import WizardBoxRight from "@/Pages/Wizard/Layouts/WizardBoxRight";
import WizardBoxLeft from "@/Pages/Wizard/Layouts/WizardBoxLeft";
import WizardStep from "@/Pages/Wizard/Elements/WizardStep";
import WizardHeader from "@/Pages/Wizard/Elements/WizardHeader";
import WizardFooter from "@/Pages/Wizard/Elements/WizardFooter";
import WizardProgress from "@/Pages/Wizard/Elements/WizardProgress";
import Button from "@/Jetstream/Button";
import Label from "@/Jetstream/Label";
import {redirectWizardSteps} from "@/helpers/helper";

export default {
    props: ['data', 'user'],

    components: {
        Label,
        Button,
        WizardProgress,
        WizardFooter, WizardHeader, WizardStep, WizardBoxLeft, WizardLayout, WizardBoxRight
    },

    computed: {
        display_next_button() {
            return this.fieldsAreEmpty()
        },

        getWizardData() {
            let values = {}

            if (this.isAgency()) {
                values = {
                    client_request_price: parseFloat(this.client_request_price.replaceAll('.', '')),
                    negotiable_price: this.negotiable_price,
                    actual_agency_price: parseFloat(this.actual_agency_price.replaceAll('.', '')),
                    after_restoration_agency_price: parseFloat(this.after_restoration_agency_price.replaceAll('.', '')),
                    is_agency: true
                }
            } else {
                values = {
                    expected_value: parseFloat(this.expected_value.replaceAll('.', '')),
                    // evaluation_value: parseFloat(this.expected_value.replaceAll('.', '')),
                }
            }

            return values
        }
    },

    data() {
        let current_property = JSON.parse(localStorage.getItem('current_property'))

        return {
            step: 7,
            header_step: this.isAgency() ? 7 : 8,
            title: "Quale pensi sia il valore del tuo immobile?",
            progress: 4,
            progress_title: "Ricevi subito la tua valutazione",
            progress_description: "Hai già un'idea di quale sia secondo te il valore del tuo immobile? Inserisci la cifra nel riquadro e clicca avanti.",
            expected_value: current_property ? this.addThousands('expected_value',String(current_property.expected_value)) : '',
            client_request_price: current_property ? this.addThousands('client_request_price',String(current_property.client_request_price)) : '',
            negotiable_price: current_property ? current_property.negotiable_price : '',
            actual_agency_price: current_property ? this.addThousands('actual_agency_price',String(current_property.actual_agency_price)) : '',
            after_restoration_agency_price: current_property ? this.addThousands('after_restoration_agency_price',String(current_property.after_restoration_agency_price)) : ''
        }
    },

    methods: {
        isAgency() {
            return (this.user !== null && !(window.location.href.includes('customer')))
        },

        fieldsAreEmpty() {
            if (this.isAgency()) {
                return (this.client_request_price !== '' && this.negotiable_price !== '' && this.actual_agency_price !== '' &&
                    this.after_restoration_agency_price !== '')
            } else {
                return this.expected_value !== ''
            }
        },

        addThousands(data, value) {
            const result = value.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.$data[data] = result);
        }
    },

    beforeMount() {
        redirectWizardSteps(this.isAgency(), this.step, 'test', this.$inertia)
    },

    watch: {
        expected_value: function (newValue) {
            this.addThousands('expected_value', newValue)
        },

        client_request_price: function (newValue) {
            this.addThousands('client_request_price', newValue)
        },

        actual_agency_price: function (newValue) {
            this.addThousands('actual_agency_price', newValue)
        },

        after_restoration_agency_price: function (newValue) {
            this.addThousands('after_restoration_agency_price', newValue)
        }
    }
}
</script>
